import { createFileRoute } from '@tanstack/react-router';
import { ReportsHomePage } from '@/features/analytics-reporting/ReportsHomePage';

export const Route = createFileRoute('/_dashboard/dashboard/reporting/reports/')({
  component: ReportsHomePage,
});
